import { useState } from 'react';
import { FaWhatsapp } from 'react-icons/fa';
import { MessageCircle, X, Sparkles, Clock, Shield } from 'lucide-react';
import { Card, CardContent, CardDescription, CardHeader, CardTitle } from '@/components/ui/card';
import { Button } from '@/components/ui/button';
import '../../App.css';

const ChatPopup = () => {
  const [isOpen, setIsOpen] = useState(false);
  const [isAnimating, setIsAnimating] = useState(false);

  const handleToggle = () => {
    setIsAnimating(true);
    setIsOpen(!isOpen);
  };

  return (
    <div className="fixed bottom-6 right-6 flex flex-col items-end z-50">
      {/* Chat bubble container */}
      <div
        style={{
          transformOrigin: 'bottom right',
          pointerEvents: isOpen ? 'auto' : 'none'
        }}
        className={`absolute bottom-16 right-0 
          ${isOpen ? 'animate-popup-expand' : isAnimating ? 'animate-popup-collapse' : 'opacity-0 scale-0'}
          transition-all duration-300`
        }
        onAnimationEnd={() => setIsAnimating(false)}
      >
        <Card className="w-80 shadow-2xl border-0 bg-white/95 backdrop-blur-sm">
          <CardHeader className="pb-4">
            <div className="flex items-center justify-between">
              <div className="flex items-center space-x-3">
                <div className="w-10 h-10 bg-gradient-to-br from-green-500 to-emerald-500 rounded-full flex items-center justify-center shadow-lg">
                  <MessageCircle className="w-5 h-5 text-white" />
                </div>
                <div>
                  <CardTitle className="text-lg font-semibold text-gray-900">Timelyyy Support</CardTitle>
                  <CardDescription className="text-sm text-green-600 flex items-center">
                    <div className="w-2 h-2 bg-green-500 rounded-full mr-2"></div>
                    Online now
                  </CardDescription>
                </div>
              </div>
              <Button
                variant="ghost"
                size="sm"
                onClick={handleToggle}
                className="h-8 w-8 p-0 hover:bg-gray-100"
              >
                <X className="w-4 h-4" />
              </Button>
            </div>
          </CardHeader>
          
          <CardContent className="space-y-4">
            {/* Message */}
            <div className="bg-gray-50 rounded-2xl p-4 border border-gray-200">
              <div className="flex items-start space-x-3">
                <div className="w-8 h-8 bg-gradient-to-br from-blue-500 to-indigo-500 rounded-full flex items-center justify-center">
                  <MessageCircle className="w-4 h-4 text-white" />
                </div>
                <div className="flex-1">
                  <p className="text-gray-800 text-sm leading-relaxed">
                    Hi! 👋 I'm here to help you with any questions about our vehicle wash services. How can I assist you today?
                  </p>
                  <div className="flex items-center mt-2 text-xs text-gray-500">
                    <Clock className="w-3 h-3 mr-1" />
                    Just now
                  </div>
                </div>
              </div>
            </div>

            {/* WhatsApp Button */}
            <a
              href="https://wa.me/7058289819"
              target="_blank"
              rel="noopener noreferrer"
              className="block"
            >
              <Button className="w-full bg-gradient-to-r from-green-600 to-emerald-600 hover:from-green-700 hover:to-emerald-700 text-white shadow-lg hover:shadow-xl transition-all duration-300 group">
                <FaWhatsapp className="w-5 h-5 mr-2" />
                Chat on WhatsApp
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  className="h-4 w-4 ml-2 transform group-hover:translate-x-1 transition-transform"
                  viewBox="0 0 20 20"
                  fill="currentColor"
                >
                  <path
                    fillRule="evenodd"
                    d="M7.293 14.707a1 1 0 010-1.414L10.586 10 7.293 6.707a1 1 0 011.414-1.414l4 4a1 1 0 010 1.414l-4 4a1 1 0 01-1.414 0z"
                    clipRule="evenodd"
                  />
                </svg>
              </Button>
            </a>

            {/* Features */}
            <div className="space-y-2">
              <div className="flex items-center space-x-2 text-xs text-gray-600">
                <Sparkles className="w-3 h-3 text-green-500" />
                <span>Instant responses</span>
              </div>
              <div className="flex items-center space-x-2 text-xs text-gray-600">
                <Shield className="w-3 h-3 text-blue-500" />
                <span>Secure & private</span>
              </div>
            </div>

            {/* Trust Indicators */}
            <div className="flex items-center justify-center space-x-4 text-xs text-gray-400 pt-2 border-t border-gray-200">
              <div className="flex items-center space-x-1">
                <Sparkles className="w-3 h-3 text-green-500" />
                <span>Fast</span>
              </div>
              <div className="flex items-center space-x-1">
                <Sparkles className="w-3 h-3 text-blue-500" />
                <span>Reliable</span>
              </div>
              <div className="flex items-center space-x-1">
                <Sparkles className="w-3 h-3 text-purple-500" />
                <span>24/7</span>
              </div>
            </div>
          </CardContent>
        </Card>
      </div>

      <Button
        className="bg-gradient-to-r from-green-500 to-emerald-500 hover:from-green-600 hover:to-emerald-600 p-4 rounded-full shadow-xl hover:shadow-2xl transition-all duration-300 focus:outline-none z-10 border-0 w-14 h-14"
        onClick={handleToggle}
      >
        {isOpen ? (
          <X className="w-6 h-6 text-white" />
        ) : (
          <MessageCircle className="w-6 h-6 text-white" />
        )}
      </Button>
    </div>
  );
};

export default ChatPopup;
